<template lang="pug">
.d-flex.flex-column.gap-4
  slot(name="label" v-bind="{ label }")
    .mb-1.font-weight-medium(v-if="label && topLabel") {{ label }}
  validation-observer
    validation-provider(
      :rules="maxCounterValue ? `max:${maxCounterValue}` : ''"
      :name="label || 'Поле ввода'"
      vid="app-textarea"
      v-slot="{ errors, invalid }"
    )
      v-textarea.app-textarea(
        ref="textArea"
        :class=`{
          'app-textarea--contrast': contrast,
        }`
        v-model="inputValue"
        v-bind="extendAttrs"
        :error-messages="[...errors, ...errorMessages]"
        :outlined="outlined && !invalid && !errorMessages.length"
      )
        template(#append)
          .d-flex.justify-space-between.flex-wrap(
            :class="{ 'align-center gap-8': soloLineInput, 'flex-column align-end': !soloLineInput }"
          )
            v-btn(
              :class="{ 'opacity-0 pointer-events-none' : !inputValue.length || readonly }"
              icon
              small
              color="redesignSecondary"
              @click="clearInput"
            )
              v-icon(size="20") $iclose
            .redesignDisabledText--text(v-if="maxCounterValue")
              span(
                :class=`{
                  'redesignError--text': invalid
                }`
              ) {{ inputValue.length }}
              | /{{ maxCounterValue }}

</template>

<script>
// REFACTOR: deprecated, replace with AppTextarea

export default {
  name: 'AppTextAreaOld',
  props: {
    value: { type: [String, Number], default: '' },
    rows: { type: [String, Number], default: 1 },
    label: { type: String, default: '' },
    topLabel: { type: Boolean, default: true },
    errorMessages: { type: Array, default: () => [] },
    outlined: { type: Boolean, default: false },
    maxCounterValue: { type: Number, default: null },
    readonly: { type: Boolean, default: false },
    areaClass: { type: [String, Array], default: '' },
    contrast: { type: Boolean, default: false },
  },
  data() {
    return {
      resizeObserver: null,
      soloLineInput: this.rows === 1,
    };
  },
  computed: {
    inputValue: {
      get() {
        return this.value || '';
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    extendAttrs() {
      const { rows, readonly, areaClass, label, topLabel } = this;
      return {
        class: areaClass || 'body-2 font-weight-light relative',
        'auto-grow': true,
        solo: true,
        flat: true,
        rows,
        'full-width': true,
        'hide-details': true,
        readonly,
        ...(topLabel ? {} : { label }),
        ...this.$attrs,
      };
    },
  },
  mounted() {
    /** Вызывает ошибку:
     * ResizeObserver loop completed with undelivered notifications.
     * Пока не знаю, как решить, поэтому просто отключаю, на функицонал не влияет.
     */
    // const input = this.textAreaInput();
    // if (input) {
    //   this.resizeObserver = new ResizeObserver(this.heightResize);
    //   this.resizeObserver.observe(input);
    // }
  },
  beforeDestroy() {
    // const input = this.textAreaInput();
    // if (input) this.resizeObserver.unobserve(input);
  },
  methods: {
    clearInput() {
      this.inputValue = '';
    },
    textAreaInput() {
      const { textArea } = this.$refs;
      if (!textArea) return null;
      return textArea.$refs.input;
    },
    heightResize(obsEntries) {
      const oneRowHeight = 50;
      const [obsEntry] = obsEntries;
      if (obsEntry?.target) {
        const { height } = obsEntry.target.getBoundingClientRect();
        this.soloLineInput = height < oneRowHeight;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.app-textarea {
  &::v-deep .v-input__control {
    min-height: 40px;
  }

  &::v-deep .v-input__slot {
    align-items: stretch;
    padding: 4px 8px !important;
    margin-bottom: 0px !important;
    min-height: 30px !important;
  }
  &::v-deep textarea {
    margin: 0 !important;
  }
  &::v-deep .v-input__append-inner {
    align-self: stretch;
    margin: 0 !important;
  }
}

::v-deep.v-input {
  &.theme--light {
    color: unset;
  }

  &--is-focused.v-text-field--outlined {
    & .v-input__control {
      & fieldset {
        border-color: currentColor !important;
      }
    }
  }
}
</style>
